import ContentLoader from 'react-content-loader';
import React from 'react';

const TableLoader = (props) => {
  return (
    <ContentLoader
      height={590}
      uniqueKey="key"
      style={{ width: '100%' }}
      backgroundColor="#f3f3f3"
      foregroundColor="#ecebeb"
      {...props}
    >
      <rect x="27" y="39" rx="4" ry="4" width="20" height="20" />
      <rect x="67" y="39" rx="10" ry="10" width="85" height="19" />
      <rect x="188" y="39" rx="10" ry="10" width="169" height="19" />
      <rect x="402" y="39" rx="10" ry="10" width="85" height="19" />
      <rect x="523" y="39" rx="10" ry="10" width="169" height="19" />
      <rect x="731" y="39" rx="10" ry="10" width="85" height="19" />
      <rect x="851" y="39" rx="10" ry="10" width="85" height="19" />
      <rect x="978" y="39" rx="10" ry="10" width="169" height="19" />
      <rect x="1182" y="39" rx="10" ry="10" width="85" height="19" />
      <rect x="1292" y="39" rx="10" ry="10" width="185" height="19" />

      <rect x="26" y="90" rx="4" ry="4" width="20" height="20" />
      <rect x="66" y="90" rx="10" ry="10" width="85" height="19" />
      <rect x="187" y="90" rx="10" ry="10" width="169" height="19" />
      <rect x="401" y="90" rx="10" ry="10" width="85" height="19" />
      <rect x="522" y="90" rx="10" ry="10" width="169" height="19" />
      <rect x="730" y="90" rx="10" ry="10" width="85" height="19" />
      <rect x="851" y="90" rx="10" ry="10" width="85" height="19" />
      <rect x="977" y="90" rx="10" ry="10" width="169" height="19" />
      <rect x="1182" y="90" rx="10" ry="10" width="85" height="19" />
      <rect x="1292" y="90" rx="10" ry="10" width="185" height="19" />

      <rect x="26" y="140" rx="4" ry="4" width="20" height="20" />
      <rect x="66" y="140" rx="10" ry="10" width="85" height="19" />
      <rect x="187" y="140" rx="10" ry="10" width="169" height="19" />
      <rect x="401" y="140" rx="10" ry="10" width="85" height="19" />
      <rect x="522" y="140" rx="10" ry="10" width="169" height="19" />
      <rect x="852" y="140" rx="10" ry="10" width="85" height="19" />
      <rect x="730" y="140" rx="10" ry="10" width="85" height="19" />
      <rect x="977" y="140" rx="10" ry="10" width="169" height="19" />
      <rect x="1183" y="139" rx="10" ry="10" width="85" height="19" />
      <rect x="851" y="190" rx="10" ry="10" width="85" height="19" />
      <rect x="1292" y="140" rx="10" ry="10" width="185" height="19" />

      <rect x="26" y="190" rx="4" ry="4" width="20" height="20" />
      <rect x="66" y="190" rx="10" ry="10" width="85" height="19" />
      <rect x="187" y="190" rx="10" ry="10" width="169" height="19" />
      <rect x="401" y="190" rx="10" ry="10" width="85" height="19" />
      <rect x="522" y="190" rx="10" ry="10" width="169" height="19" />
      <rect x="730" y="190" rx="10" ry="10" width="85" height="19" />
      <rect x="977" y="190" rx="10" ry="10" width="169" height="19" />
      <rect x="1182" y="190" rx="10" ry="10" width="85" height="19" />
      <rect x="1292" y="190" rx="10" ry="10" width="185" height="19" />

      <rect x="26" y="240" rx="4" ry="4" width="20" height="20" />
      <rect x="66" y="240" rx="10" ry="10" width="85" height="19" />
      <rect x="187" y="240" rx="10" ry="10" width="169" height="19" />
      <rect x="401" y="240" rx="10" ry="10" width="85" height="19" />
      <rect x="522" y="240" rx="10" ry="10" width="169" height="19" />
      <rect x="730" y="240" rx="10" ry="10" width="85" height="19" />
      <rect x="851" y="240" rx="10" ry="10" width="85" height="19" />
      <rect x="977" y="240" rx="10" ry="10" width="169" height="19" />
      <rect x="1182" y="240" rx="10" ry="10" width="85" height="19" />
      <rect x="1292" y="240" rx="10" ry="10" width="185" height="19" />

      <rect x="26" y="290" rx="4" ry="4" width="20" height="20" />
      <rect x="66" y="290" rx="10" ry="10" width="85" height="19" />
      <rect x="187" y="290" rx="10" ry="10" width="169" height="19" />
      <rect x="401" y="290" rx="10" ry="10" width="85" height="19" />
      <rect x="522" y="290" rx="10" ry="10" width="169" height="19" />
      <rect x="730" y="290" rx="10" ry="10" width="85" height="19" />
      <rect x="851" y="290" rx="10" ry="10" width="85" height="19" />
      <rect x="977" y="290" rx="10" ry="10" width="169" height="19" />
      <rect x="1182" y="290" rx="10" ry="10" width="85" height="19" />
      <rect x="1292" y="290" rx="10" ry="10" width="185" height="19" />

      <rect x="26" y="340" rx="4" ry="4" width="20" height="20" />
      <rect x="66" y="340" rx="10" ry="10" width="85" height="19" />
      <rect x="187" y="340" rx="10" ry="10" width="169" height="19" />
      <rect x="401" y="340" rx="10" ry="10" width="85" height="19" />
      <rect x="522" y="340" rx="10" ry="10" width="169" height="19" />
      <rect x="730" y="340" rx="10" ry="10" width="85" height="19" />
      <rect x="851" y="340" rx="10" ry="10" width="85" height="19" />
      <rect x="977" y="340" rx="10" ry="10" width="169" height="19" />
      <rect x="1182" y="340" rx="10" ry="10" width="85" height="19" />
      <rect x="1292" y="340" rx="10" ry="10" width="185" height="19" />

      <rect x="26" y="390" rx="4" ry="4" width="20" height="20" />
      <rect x="66" y="390" rx="10" ry="10" width="85" height="19" />
      <rect x="187" y="390" rx="10" ry="10" width="169" height="19" />
      <rect x="401" y="390" rx="10" ry="10" width="85" height="19" />
      <rect x="522" y="390" rx="10" ry="10" width="169" height="19" />
      <rect x="730" y="390" rx="10" ry="10" width="85" height="19" />
      <rect x="851" y="390" rx="10" ry="10" width="85" height="19" />
      <rect x="977" y="390" rx="10" ry="10" width="169" height="19" />
      <rect x="1182" y="390" rx="10" ry="10" width="85" height="19" />
      <rect x="1292" y="390" rx="10" ry="10" width="185" height="19" />

      <rect x="26" y="440" rx="4" ry="4" width="20" height="20" />
      <rect x="66" y="440" rx="10" ry="10" width="85" height="19" />
      <rect x="187" y="440" rx="10" ry="10" width="169" height="19" />
      <rect x="401" y="440" rx="10" ry="10" width="85" height="19" />
      <rect x="522" y="440" rx="10" ry="10" width="169" height="19" />
      <rect x="730" y="440" rx="10" ry="10" width="85" height="19" />
      <rect x="851" y="440" rx="10" ry="10" width="85" height="19" />
      <rect x="977" y="440" rx="10" ry="10" width="169" height="19" />
      <rect x="1182" y="440" rx="10" ry="10" width="85" height="19" />
      <rect x="1292" y="440" rx="10" ry="10" width="185" height="19" />

      <rect x="26" y="490" rx="4" ry="4" width="20" height="20" />
      <rect x="66" y="490" rx="10" ry="10" width="85" height="19" />
      <rect x="187" y="490" rx="10" ry="10" width="169" height="19" />
      <rect x="401" y="490" rx="10" ry="10" width="85" height="19" />
      <rect x="522" y="490" rx="10" ry="10" width="169" height="19" />
      <rect x="730" y="490" rx="10" ry="10" width="85" height="19" />
      <rect x="851" y="490" rx="10" ry="10" width="85" height="19" />
      <rect x="977" y="490" rx="10" ry="10" width="169" height="19" />
      <rect x="1182" y="490" rx="10" ry="10" width="85" height="19" />
      <rect x="1292" y="490" rx="10" ry="10" width="185" height="19" />

      <rect x="26" y="540" rx="4" ry="4" width="20" height="20" />
      <rect x="66" y="540" rx="10" ry="10" width="85" height="19" />
      <rect x="187" y="540" rx="10" ry="10" width="169" height="19" />
      <rect x="401" y="540" rx="10" ry="10" width="85" height="19" />
      <rect x="522" y="540" rx="10" ry="10" width="169" height="19" />
      <rect x="730" y="540" rx="10" ry="10" width="85" height="19" />
      <rect x="851" y="540" rx="10" ry="10" width="85" height="19" />
      <rect x="977" y="540" rx="10" ry="10" width="169" height="19" />
      <rect x="1182" y="540" rx="10" ry="10" width="85" height="19" />
      <rect x="1292" y="540" rx="10" ry="10" width="185" height="19" />

      <rect x="26" y="590" rx="4" ry="4" width="20" height="20" />
      <rect x="66" y="590" rx="10" ry="10" width="85" height="19" />
      <rect x="187" y="590" rx="10" ry="10" width="169" height="19" />
      <rect x="401" y="590" rx="10" ry="10" width="85" height="19" />
      <rect x="522" y="590" rx="10" ry="10" width="169" height="19" />
      <rect x="730" y="590" rx="10" ry="10" width="85" height="19" />
      <rect x="851" y="590" rx="10" ry="10" width="85" height="19" />
      <rect x="977" y="590" rx="10" ry="10" width="169" height="19" />
      <rect x="1182" y="590" rx="10" ry="10" width="85" height="19" />
      <rect x="1292" y="590" rx="10" ry="10" width="185" height="19" />

      <rect x="26" y="640" rx="4" ry="4" width="20" height="20" />
      <rect x="66" y="640" rx="10" ry="10" width="85" height="19" />
      <rect x="187" y="640" rx="10" ry="10" width="169" height="19" />
      <rect x="401" y="640" rx="10" ry="10" width="85" height="19" />
      <rect x="522" y="640" rx="10" ry="10" width="169" height="19" />
      <rect x="730" y="640" rx="10" ry="10" width="85" height="19" />
      <rect x="851" y="640" rx="10" ry="10" width="85" height="19" />
      <rect x="977" y="640" rx="10" ry="10" width="169" height="19" />
      <rect x="1182" y="640" rx="10" ry="10" width="85" height="19" />
      <rect x="1292" y="640" rx="10" ry="10" width="185" height="19" />

      <rect x="26" y="690" rx="4" ry="4" width="20" height="20" />
      <rect x="66" y="690" rx="10" ry="10" width="85" height="19" />
      <rect x="187" y="690" rx="10" ry="10" width="169" height="19" />
      <rect x="401" y="690" rx="10" ry="10" width="85" height="19" />
      <rect x="522" y="690" rx="10" ry="10" width="169" height="19" />
      <rect x="730" y="690" rx="10" ry="10" width="85" height="19" />
      <rect x="851" y="690" rx="10" ry="10" width="85" height="19" />
      <rect x="977" y="690" rx="10" ry="10" width="169" height="19" />
      <rect x="1182" y="690" rx="10" ry="10" width="85" height="19" />
      <rect x="1292" y="690" rx="10" ry="10" width="185" height="19" />

      <rect x="26" y="740" rx="4" ry="4" width="20" height="20" />
      <rect x="66" y="740" rx="10" ry="10" width="85" height="19" />
      <rect x="187" y="740" rx="10" ry="10" width="169" height="19" />
      <rect x="401" y="740" rx="10" ry="10" width="85" height="19" />
      <rect x="522" y="740" rx="10" ry="10" width="169" height="19" />
      <rect x="730" y="740" rx="10" ry="10" width="85" height="19" />
      <rect x="851" y="740" rx="10" ry="10" width="85" height="19" />
      <rect x="977" y="740" rx="10" ry="10" width="169" height="19" />
      <rect x="1182" y="740" rx="10" ry="10" width="85" height="19" />
      <rect x="1292" y="740" rx="10" ry="10" width="185" height="19" />

      <rect x="26" y="790" rx="4" ry="4" width="20" height="20" />
      <rect x="66" y="790" rx="10" ry="10" width="85" height="19" />
      <rect x="187" y="790" rx="10" ry="10" width="169" height="19" />
      <rect x="401" y="790" rx="10" ry="10" width="85" height="19" />
      <rect x="522" y="790" rx="10" ry="10" width="169" height="19" />
      <rect x="730" y="790" rx="10" ry="10" width="85" height="19" />
      <rect x="851" y="790" rx="10" ry="10" width="85" height="19" />
      <rect x="977" y="790" rx="10" ry="10" width="169" height="19" />
      <rect x="1182" y="790" rx="10" ry="10" width="85" height="19" />
      <rect x="1292" y="790" rx="10" ry="10" width="185" height="19" />

      <rect x="26" y="840" rx="4" ry="4" width="20" height="20" />
      <rect x="66" y="840" rx="10" ry="10" width="85" height="19" />
      <rect x="187" y="840" rx="10" ry="10" width="169" height="19" />
      <rect x="401" y="840" rx="10" ry="10" width="85" height="19" />
      <rect x="522" y="840" rx="10" ry="10" width="169" height="19" />
      <rect x="730" y="840" rx="10" ry="10" width="85" height="19" />
      <rect x="851" y="840" rx="10" ry="10" width="85" height="19" />
      <rect x="977" y="840" rx="10" ry="10" width="169" height="19" />
      <rect x="1182" y="840" rx="10" ry="10" width="85" height="19" />
      <rect x="1292" y="840" rx="10" ry="10" width="185" height="19" />

      <rect x="26" y="890" rx="4" ry="4" width="20" height="20" />
      <rect x="66" y="890" rx="10" ry="10" width="85" height="19" />
      <rect x="187" y="890" rx="10" ry="10" width="169" height="19" />
      <rect x="401" y="890" rx="10" ry="10" width="85" height="19" />
      <rect x="522" y="890" rx="10" ry="10" width="169" height="19" />
      <rect x="730" y="890" rx="10" ry="10" width="85" height="19" />
      <rect x="851" y="890" rx="10" ry="10" width="85" height="19" />
      <rect x="977" y="890" rx="10" ry="10" width="169" height="19" />
      <rect x="1182" y="890" rx="10" ry="10" width="85" height="19" />
      <rect x="1292" y="890" rx="10" ry="10" width="185" height="19" />
    </ContentLoader>
  );
};

TableLoader.metadata = {
  name: 'Shaheer Ali',
  github: 'itsmeshaheerali',
  description:
    'This loader exactly fit inside your bootrstrap card component no override happens like existing DataTable Loader',
  filename: 'BootstrapCardDataTable',
};

export default TableLoader;
